import React, { useEffect, useState } from "react";
import { Spinner} from "reactstrap";
import Contact from "../Contact/Contact";
import classes from './Contacts.module.scss';
import { TextField } from "@mui/material";
import _ from 'lodash';
import { boxiPrimary } from "../../../../assets/style/colors";
import CircleNotificationsRoundedIcon from '@mui/icons-material/CircleNotificationsRounded';
import { IconButton } from "@mui/material";
import RemainderMessageModal from "../RemainderMessageModal/RemainderMessageModal"
import InfiniteScroll from 'react-infinite-scroll-component';

const Contacts = ({ activeTab, setPaginationStatus, getNextChats, listingOffset, setListingOffset, totalChatsCounts, setIsCurrentChatPictureBlast ,setVendorId, setIsCurrentChatBlocked, contacts, onContactSelect, isLoading, setVendorName, searchValue, setSearchValue, getChatsCount, selectedVendorDetails, threadShouldSelected, setThreadShouldSelected, searchedContactFetched }) => {
  
  const [selectedContact, setSelectedContact] = useState(null);
  const [inputValue, setInputValue] = useState(null)
  const [pictureBlastReminderModal, setPictureBlastReminderModal] = useState(false)

  const contactClickHandler = (vendor_id, phone_number, name, is_blocked, is_pictures) => {
    setIsCurrentChatBlocked(is_blocked)
    setIsCurrentChatPictureBlast(is_pictures)
    onContactSelect(vendor_id, phone_number, true);
    setVendorName(name);
    setVendorId(vendor_id);
    setSelectedContact(phone_number)
  }

  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value) {
        setThreadShouldSelected(false)
        setListingOffset(0)
        setPaginationStatus(1)
        setSearchValue(inputValue);
      } else if (value === '') { setPaginationStatus(2); setSearchValue('');  setListingOffset(0); }
    }, 2000);

    debouncedHandler(inputValue);

    return () => {
      setPictureBlastReminderModal(false);
      debouncedHandler.cancel();
    };
  }, [inputValue]);

  // this use effect is use when communication tab act as a widget and selected the respective thread and only that chat is shown, and also vissible in search bar
  useEffect(()=>{
    if(threadShouldSelected){
      selectedVendorDetails && setInputValue(selectedVendorDetails.phoneNumber)
      selectedVendorDetails && setSearchValue(selectedVendorDetails.phoneNumber);
    }
  }, [threadShouldSelected, selectedVendorDetails])

  // useEffect added to reduce api calls and select contact as chats fetched
  useEffect(()=>{
    (selectedVendorDetails && searchedContactFetched && threadShouldSelected) && contactClickHandler(selectedVendorDetails.vendorId  , selectedVendorDetails.phoneNumber, selectedVendorDetails.vendorName, false, false);
  },[searchedContactFetched])
 // 
  return (
    <>
      {/* {isLoading ? 
        <>
          <Spinner></Spinner>
        </> 
        : 
      } */}
        <div className={classes.chatListContainer}>
          {isLoading && <div className={classes.spinnerContainer}>
            <Spinner className={classes.spinner123} style={{ color: boxiPrimary }}></Spinner>
          </div>}
          <TextField 
            id="thread-search"
            label="Search"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            variant="standard"
            className="MuiTextField-standard"
          />
          {activeTab === 4 && (
          <IconButton
            style={{
              position: 'absolute',
              zIndex: '9',
              right: '10px',
              top: '5px'
            }}
            disabled={false}
            onClick={() => setPictureBlastReminderModal(true)}
          >
            <CircleNotificationsRoundedIcon
                  style={{
                    color: boxiPrimary,
                    cursor: 'pointer',
                    height: '30px',
                    width: '30px'
                  }}
            />
          </IconButton>
          )}
          <div className={classes.chatList}>
            <InfiniteScroll
              dataLength={contacts.length}
              hasMore={contacts.length !== totalChatsCounts}
              next={() => { setListingOffset((prev) => prev + 1); setPaginationStatus(0); }}
              height={window.innerHeight - 160}
              loader={contacts.length !== totalChatsCounts && <div style={{ margin: '10px auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
            >  
              {contacts && contacts.length > 0 && contacts.map((contact, index) => 
                { 
                  return <Contact
                  key={contact.id} 
                  index={index}
                  contact={contact} 
                  selectedContact={selectedContact}
                  getChatsCount = {getChatsCount}
                  onContactClick={() => {contactClickHandler(contact.vendor_id, contact.phone_number, contact.name, contact.is_blocked, contact.is_pictures); getChatsCount()}}
                />}
              )}
            </InfiniteScroll>
          </div>
        </div>
      {pictureBlastReminderModal && activeTab === 4 && (<RemainderMessageModal openModal={setPictureBlastReminderModal} isModalOpen={pictureBlastReminderModal} />)}
    </>
  );
}
export default Contacts;